import React, { useEffect, useState } from 'react';
import Profile from '../components/Profile';
import Members from '../components/Members';
import Invitations from '../components/Invitations';
import DashboardLayout from '../components/DashboardLayout';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CreateInvitation from '../components/CreateInvitation';
import Complaints from '../components/Complaints';
import Connections from '../components/Connections';

const Dashboard = () => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
  // eslint-disable-next-line
  const [ profileData,setProfileData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        setIsLoading(true);
        const token = localStorage.getItem('accessToken');
        if (!token) {
          navigate('/login');
          return;
        }

        // Fetch fresh profile data
        const response = await fetch(
          `${API_URL}/api/v1/auth/profile?access_token=${encodeURIComponent(token)}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        if (!response.ok) {
          if (response.status === 401) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('profileData');
            navigate('/login');
            return;
          }
          throw new Error(`Failed to fetch profile: ${response.statusText}`);
        }

        const data = await response.json();
        
        const formattedData = {
          name: data.Profile.FullName || `${data.Profile.FirstName} ${data.Profile.LastName}`.trim(),
          email: data.Profile.Email?.[0]?.Value || '',
          id: data.Profile.ID,
          uid: data.Profile.Uid,
          provider: data.Profile.Provider,
          Profile: data.Profile,
          Orgs: data.Orgs.map(org => ({
            OrgId: org.OrgId,
            Name: org.Name || org.OrgName,
            Permissions: org.Permissions
          }))
        };

        setProfileData(formattedData);
        localStorage.setItem('profileData', JSON.stringify(formattedData));

        // Update societies in localStorage
        if (formattedData.Orgs && formattedData.Orgs.length > 0) {
          localStorage.setItem('societies', JSON.stringify(formattedData.Orgs));
          
          // Set default society if none is selected
          const currentSocietyId = localStorage.getItem('societyId');
          if (!currentSocietyId) {
            localStorage.setItem('societyId', formattedData.Orgs[0].OrgId);
          }
        }

      } catch (error) {
        console.error('Error fetching profile:', error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProfile();
    // eslint-disable-next-line
  }, [navigate, isAuthenticated]);

  if (error) {
    return <div className="error-message">Error loading profile: {error}</div>;
  }

  if (isLoading) {
    return <div className="loading">Loading dashboard...</div>;
  }

  return (
    <DashboardLayout>
      {{
        profile: <Profile />,
        members: <Members />,
        invitations: <Invitations />,
        createInvitation: <CreateInvitation />,
        complaints: <Complaints />,
        connections: <Connections />
      }}
    </DashboardLayout>
  );
};

export default Dashboard; 